<div class="footer-panel">
  <!-- Header -->
  <div class="panel-header">
    <h3 class="panel-title">Footer Section</h3>
    <button class="close-btn" (click)="onClose()" aria-label="Close panel">
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path
          d="M15 5L5 15M5 5L15 15"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
        />
      </svg>
    </button>
  </div>

  <!-- Tabs -->
  <div class="tabs-container">
    <div class="segment-control">
      <button
        class="segment-btn"
        [class.active]="activeTab === 'content'"
        (click)="switchTab('content')"
      >
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
          <path
            d="M3 6h12M3 10h12M3 14h8"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
          />
        </svg>
        Content
      </button>
      <button
        class="segment-btn"
        [class.active]="activeTab === 'layout'"
        (click)="switchTab('layout')"
      >
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
          <rect x="3" y="3" width="5" height="5" stroke="currentColor" stroke-width="1.5" />
          <rect x="10" y="3" width="5" height="5" stroke="currentColor" stroke-width="1.5" />
          <rect x="3" y="10" width="5" height="5" stroke="currentColor" stroke-width="1.5" />
          <rect x="10" y="10" width="5" height="5" stroke="currentColor" stroke-width="1.5" />
        </svg>
        Layout
      </button>
    </div>
  </div>

  <!-- Content Tab -->
  <div class="panel-content" *ngIf="activeTab === 'content'">
    <!-- Media Section -->
    <app-section-accordion
      title="Media"
      [isExpanded]="isSectionExpanded('media')"
      (toggle)="toggleSection('media')"
    >
      <div class="accordion-content">
        <!-- Hidden file input (always available for replace functionality) -->
        <input
          type="file"
          id="footer-logo-upload"
          class="file-input"
          accept="image/png,image/jpeg,image/jpg,image/gif,image/svg+xml,video/mp4"
          (change)="onFileSelected($event)"
          [disabled]="isUploadingLogo"
          style="display: none"
        />

        <!-- Logo Preview Section (when logo exists) -->
        <div class="logo-upload-wrapper" *ngIf="logoPreview">
          <!-- Logo Preview -->
          <div class="logo-preview-container">
            <div class="logo-preview-area">
              <img
                [src]="logoPreview"
                alt="Logo preview"
                class="logo-image"
                *ngIf="!isUploadingLogo"
              />
              <div class="logo-loading" *ngIf="isUploadingLogo">
                <div class="loading-spinner"></div>
              </div>
            </div>

            <!-- Replace Button -->
            <button class="replace-button" (click)="onReplaceLogo()" [disabled]="isUploadingLogo">
              Replace
            </button>

            <!-- File Format Info -->
            <div class="file-info">
              <span class="file-info-text">Accepted formats - .png, .jpg, .jpeg, .mp4</span>
              <span class="file-info-divider">|</span>
              <span class="file-info-text">Max file size - 5MB</span>
            </div>
          </div>

          <div class="upload-error" *ngIf="uploadError">
            {{ uploadError }}
          </div>
        </div>

        <!-- Upload Area (when no logo exists) -->
        <div class="logo-upload-wrapper" *ngIf="!logoPreview">
          <div
            class="upload-area"
            [class.disabled]="isUploadingLogo"
            (drop)="onDrop($event)"
            (dragover)="onDragOver($event)"
          >
            <label for="footer-logo-upload" class="upload-label">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path
                  d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4M17 8l-5-5-5 5M12 3v12"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              <span class="upload-text">
                <span class="upload-link">Click to upload</span> or drag and drop
              </span>
              <span class="upload-hint">PNG, JPG, GIF, or SVG (max. 5MB)</span>
            </label>
          </div>

          <div class="upload-error" *ngIf="uploadError">
            {{ uploadError }}
          </div>
        </div>

        <!-- How should the image look dropdown -->
        <div class="form-group">
          <label class="form-label">How should the image look?</label>
          <select class="form-select">
            <option value="fill">Fill</option>
            <option value="fit">Fit</option>
            <option value="stretch">Stretch</option>
          </select>
        </div>
      </div>
    </app-section-accordion>

    <!-- Quick Links Section -->
    <app-section-accordion
      title="Quick Links"
      [isExpanded]="isSectionExpanded('quick_links')"
      (toggle)="toggleSection('quick_links')"
    >
      <div class="accordion-content">
        <div class="form-group">
          <label class="form-label">Section Title</label>
          <input
            type="text"
            class="form-input"
            [(ngModel)]="data.quickLinksTitle"
            (ngModelChange)="onQuickLinksTitleChange()"
            placeholder="Quick links"
          />
        </div>
      </div>
    </app-section-accordion>

    <!-- Individual Quick Links -->
    <app-section-accordion
      *ngFor="let link of getQuickLinks(); let i = index; trackBy: trackByIndex"
      [title]="'Link ' + (i + 1)"
      [isExpanded]="isSectionExpanded('link_' + i)"
      (toggle)="toggleSection('link_' + i)"
    >
      <div class="accordion-content">
        <div class="form-group">
          <label class="form-label">Page title*</label>
          <input
            type="text"
            class="form-input"
            [class.error]="pageTitleErrors[i]"
            [(ngModel)]="link.label"
            (ngModelChange)="onQuickLinkChange(i, $event)"
            (input)="onPageTitleInput($event, i)"
            [maxlength]="MAX_PAGE_TITLE_LENGTH"
            placeholder="Home"
          />
          <div class="error-message" *ngIf="pageTitleErrors[i]">
            {{ pageTitleErrors[i] }}
          </div>
          <div
            class="char-count"
            [class.warning]="(link.label?.length || 0) >= MAX_PAGE_TITLE_LENGTH - 3"
          >
            {{ link.label?.length || 0 }}/{{ MAX_PAGE_TITLE_LENGTH }}
          </div>
        </div>

        <!-- Information Banner -->
        <div class="info-banner">
          <div class="info-icon">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <circle cx="10" cy="10" r="9" stroke="#3B82F6" stroke-width="1.5" fill="none" />
              <path
                d="M10 14V10M10 6H10.01"
                stroke="#3B82F6"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
          <div class="info-content">
            <div class="info-title">Page titles are global!</div>
            <div class="info-description">
              Page titles will be same across all the instances they are used. i.e., in the
              navigation tabs, footer and also in the page settings.
            </div>
          </div>
        </div>
      </div>
    </app-section-accordion>

    <!-- Social Media Links Section -->
    <app-section-accordion
      title="Social Media Links"
      [isExpanded]="isSectionExpanded('social')"
      (toggle)="toggleSection('social')"
    >
      <div class="accordion-content">
        <div class="form-group">
          <label class="form-label">Section Title</label>
          <input
            type="text"
            class="form-input"
            [(ngModel)]="data.socialLinksTitle"
            (ngModelChange)="onSocialLinksTitleChange()"
            placeholder="Connect with us"
          />
        </div>
        <div class="social-links-list">
          <div
            class="social-link-item"
            *ngFor="let social of getSocialLinks(); let i = index; trackBy: trackByIndex"
          >
            <div class="form-group">
              <label class="form-label">Platform</label>
              <select
                class="form-select"
                [class.error]="socialLinkErrors[i]"
                [(ngModel)]="social.platform"
                (ngModelChange)="onSocialLinkChange(i, $event)"
              >
                <option value="Instagram" [disabled]="isPlatformDisabled('Instagram', i)">
                  Instagram
                </option>
                <option value="Facebook" [disabled]="isPlatformDisabled('Facebook', i)">
                  Facebook
                </option>
                <option value="YouTube" [disabled]="isPlatformDisabled('YouTube', i)">
                  YouTube
                </option>
                <option value="LinkedIn" [disabled]="isPlatformDisabled('LinkedIn', i)">
                  LinkedIn
                </option>
                <option value="X" [disabled]="isPlatformDisabled('X', i)">X</option>
                <option value="Twitter" [disabled]="isPlatformDisabled('Twitter', i)">
                  Twitter
                </option>
                <option value="Pinterest" [disabled]="isPlatformDisabled('Pinterest', i)">
                  Pinterest
                </option>
                <option value="TikTok" [disabled]="isPlatformDisabled('TikTok', i)">TikTok</option>
              </select>
              <div class="error-message" *ngIf="socialLinkErrors[i]">
                {{ socialLinkErrors[i] }}
              </div>
            </div>
            <div class="form-group">
              <label class="form-label">URL</label>
              <input
                type="text"
                class="form-input"
                [(ngModel)]="social.url"
                (ngModelChange)="onSocialLinkChange(i)"
                placeholder="https://..."
              />
            </div>
            <div class="form-group">
              <label class="form-label">Icon</label>
              <select
                class="form-select"
                [(ngModel)]="social.icon"
                (ngModelChange)="onSocialLinkChange(i)"
              >
                <option value="instagram">Instagram</option>
                <option value="facebook">Facebook</option>
                <option value="youtube">YouTube</option>
                <option value="linkedin">LinkedIn</option>
                <option value="x">X</option>
                <option value="twitter">Twitter</option>
                <option value="pinterest">Pinterest</option>
                <option value="tiktok">TikTok</option>
              </select>
            </div>
            <button
              class="remove-button"
              (click)="removeSocialLink(i)"
              *ngIf="getSocialLinks().length > 1"
            >
              Remove
            </button>
          </div>
        </div>
        <button class="add-button" (click)="addSocialLink()">+ Add Social Link</button>
      </div>
    </app-section-accordion>

    <!-- Copyright Section -->
    <app-section-accordion
      title="Copyright"
      [isExpanded]="isSectionExpanded('copyright')"
      (toggle)="toggleSection('copyright')"
    >
      <div class="accordion-content">
        <div class="form-group">
          <label class="form-label">Copyright Text</label>
          <input
            type="text"
            class="form-input"
            [(ngModel)]="data.copyright"
            (ngModelChange)="onCopyrightChange()"
            placeholder="Copyright © 2025 way.com. All rights reserved."
          />
        </div>
      </div>
    </app-section-accordion>

    <!-- Background Section -->
    <app-section-accordion
      title="Background"
      [isExpanded]="isSectionExpanded('background')"
      (toggle)="toggleSection('background')"
    >
      <div class="accordion-content">
        <!-- Color Swatches -->
        <div class="color-palette">
          <div class="color-list">
            <!-- Purple Color -->
            <div
              class="color-item"
              [class.selected]="data.backgroundColor === '#5E19A1'"
              (click)="onBackgroundColorChange('#5E19A1')"
            >
              <div class="color-swatch" style="background-color: #5e19a1"></div>
              <span class="color-code">#5E19A1</span>
              <div class="checkmark" *ngIf="data.backgroundColor === '#5E19A1'">
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                  <path
                    d="M10 3L4.5 8.5L2 6"
                    stroke="#079271"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
            </div>

            <!-- Orange Color -->
            <div
              class="color-item"
              [class.selected]="data.backgroundColor === '#FF9736'"
              (click)="onBackgroundColorChange('#FF9736')"
            >
              <div class="color-swatch" style="background-color: #ff9736"></div>
              <span class="color-code">#FF9736</span>
              <div class="checkmark" *ngIf="data.backgroundColor === '#FF9736'">
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                  <path
                    d="M10 3L4.5 8.5L2 6"
                    stroke="#079271"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
            </div>

            <!-- Green Color -->
            <div
              class="color-item"
              [class.selected]="data.backgroundColor === '#079271'"
              (click)="onBackgroundColorChange('#079271')"
            >
              <div class="color-swatch" style="background-color: #079271"></div>
              <span class="color-code">#079271</span>
              <div class="checkmark" *ngIf="data.backgroundColor === '#079271'">
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                  <path
                    d="M10 3L4.5 8.5L2 6"
                    stroke="#079271"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
            </div>

            <!-- Blue Color -->
            <div
              class="color-item"
              [class.selected]="data.backgroundColor === '#1B5BFF'"
              (click)="onBackgroundColorChange('#1B5BFF')"
            >
              <div class="color-swatch" style="background-color: #1b5bff"></div>
              <span class="color-code">#1B5BFF</span>
              <div class="checkmark" *ngIf="data.backgroundColor === '#1B5BFF'">
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                  <path
                    d="M10 3L4.5 8.5L2 6"
                    stroke="#079271"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
            </div>
          </div>

          <!-- Divider -->
          <div class="color-divider"></div>

          <!-- Add Color Button -->
          <div class="add-color-section">
            <div class="color-item add-color" (click)="onAddColor()">
              <div class="color-swatch add-color-swatch">
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                  <path
                    d="M6 1V11M1 6H11"
                    stroke="#15172E"
                    stroke-width="1.5"
                    stroke-linecap="round"
                  />
                </svg>
              </div>
              <span class="color-code">Add Color</span>
            </div>
          </div>

          <!-- Custom Colors (dynamically added) -->
          <div
            class="color-item"
            *ngFor="let customColor of customColors; trackBy: trackByIndex"
            [class.selected]="data.backgroundColor === customColor"
            (click)="openColorPicker(customColor)"
          >
            <div class="color-swatch" [style.background-color]="customColor"></div>
            <span class="color-code">{{ customColor }}</span>
            <div class="checkmark" *ngIf="data.backgroundColor === customColor">
              <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                <path
                  d="M10 3L4.5 8.5L2 6"
                  stroke="#079271"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
          </div>
        </div>
      </div>
    </app-section-accordion>
  </div>

  <!-- Layout Tab -->
  <div class="panel-content" *ngIf="activeTab === 'layout'">
    <div class="empty-state">
      <p>Layout options coming soon</p>
    </div>
  </div>

  <!-- Color Picker Modal -->
  <div class="color-picker-overlay" *ngIf="isColorPickerOpen" (click)="closeColorPicker()">
    <div class="color-picker-modal" (click)="$event.stopPropagation()">
      <div class="color-picker-header">
        <h3 class="color-picker-title">Color picker</h3>
        <button class="color-picker-close" (click)="closeColorPicker()">
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
            <path
              d="M1 1L11 11M11 1L1 11"
              stroke="#15172E"
              stroke-width="1.5"
              stroke-linecap="round"
            />
          </svg>
        </button>
      </div>

      <div class="color-picker-content">
        <chrome-picker [(color)]="currentPickerColor" (colorChange)="onColorPickerChange()">
        </chrome-picker>
      </div>
    </div>
  </div>
</div>
